export default __webpack_public_path__ + "static/media/cohort-community.292b14ce.svg";